import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const MinusBackground = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg width={props.width ?? 96} height={props.height ?? 29} viewBox="0 0 100 94" fill="none">
          <Path
            d="M0.273438 0.263672H95.8047V28.923H0.273438V0.263672Z"
            fill={props.color ?? '#FFF5DD'}
            fillOpacity="0.95"
          />
        </Svg>
      </View>
    );
  },
);

export { MinusBackground };
